<template>
  <div class="free">
    <div class="free-img">
      <img src="https://imgcdn.chuxingyouhui.com/blackunique/upload/00e5f280ae9953cd37a142bc33e9eee8.png">
    </div>
    <div class="title">
      获得返现
      <span class="unit">¥</span>
      <span class="money">{{ resultInfo.rewardAmount }}</span>
    </div>
    <div class="tips">
      免单订单号: {{ resultInfo.orderId }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'Free',
  props: {
    resultInfo: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../scale.scss';
.free {
  display: flex;
  flex-direction: column;
  width: 630px * $scale;
  .free-img {
    height: 191px * $scale;
    margin-top: 43px * $scale;
    margin-bottom: 22px * $scale;
    img {
      height: 100%;
      object-fit: cover;
    }
  }
  .title {
    font-size: 28px * $scale;
    font-weight: 500;
    color: #333333;
    line-height: 44px * $scale;
    span {
      color: #FF0800;
    }
    .unit {
      margin-left: 8px * $scale;
      line-height: 34px * $scale;
    }
    .money {
      margin-left: 2px * $scale;
      font-size: 56px * $scale;
      font-weight: 600;
      line-height: 56px * $scale;
    }
  }
  .tips {
    margin-top: 24px * $scale;
    font-size: 24px * $scale;
    line-height: 24px * $scale;
    color: #999;
    margin-bottom: 54px * $scale;
  }
}
</style>
